import * as types from '../types.js';

export default {

	html: `
		<style>
			#output-purchase-form #company_id  { width: 15rem; }
			#output-purchase-form #warehouse_id { width: 15rem; }
			#output-purchase-form #date_from,
			#output-purchase-form #date_to     { width: 10rem; }
		</style>
		<form id="output-purchase-form" class="form" autocomplete="off">
			<datalist id="opr-companies"></datalist>
			<datalist id="opr-warehouses"></datalist>
			<div class="title">Saídas para Compras (CSV)</div>
			<p class="mts fss" style="color:var(--color-muted)">
				Exporta baixas físicas de estoque no período (SKU, lote, quantidade, fabricante e fornecedor da entrada de origem).
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="opr-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Até<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armazém (opcional)
					<input id="warehouse_id" type="text" list="opr-warehouses">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Exportar CSV</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#output-purchase-form',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#opr-companies',  'companies',  { labels: ['nick'] });
			formset.loadList('#opr-warehouses', 'warehouses', { labels: ['name'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id'  }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from'   }, types: [types.pubsub()] },
		{ properties: { selector: '#date_to'     }, types: [types.pubsub()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
	],

};
